import { render, staticRenderFns } from "./MultiLineLabel.vue?vue&type=template&id=1d2be48f&"
import script from "./MultiLineLabel.vue?vue&type=script&lang=js&"
export * from "./MultiLineLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports